import React from 'react';
import './style.scss';


export default (particularForm) => ( class Success extends React.Component<any> {
    constructor(props) {
        super(props);
    }

    render() {
        const { fields } = this.props;
        return (
            <div>
                <div className="success-box">
                    <p>El formulario se ha enviado con éxito.</p>
                </div>
                <table>
                    <tbody>
                        <tr>
                            <td>Número de cliente en Booking.com</td>
                            <td>{fields.client_number}</td>
                        </tr>
                        <tr>
                            <td>Nombre de la propiedad</td>
                            <td>{fields.property_name}</td>
                        </tr>
                        <tr>
                            <td>Nombre de propietario de cuenta bancaria</td>
                            <td>{fields.holder_name}</td>
                        </tr>
                        <tr>
                            <td>Email</td>
                            <td>{fields.email}</td>
                        </tr>
                        <tr>
                            <td>Número de factura</td>
                            <td>{fields.invoice_number}</td>
                        </tr>
                        { particularForm.renderFields.bind(this)() }
                        
                    </tbody>
                </table>
            </div>
        );
    }
}
);